import English from './entries/en-US';

const AppLocale = {
  en: English,
};

export default AppLocale;
